@if (!newBillingDesign) {
  <div class="row" id="billing-statement-history-component">
    <div class="column twelve">
      @if (!!historyList?.length && (statementHistoryLoaded$ | async) === true) {
        <form
          id="statementHistoryForm"
          [formGroup]="billingPaymentsHistoryForm"
          data-cy="statementHistoryForm"
        >
          <div class="filter-date-container">
            <span
              tabindex="0"
              class="filter-date-label"
              dsContent
              [contentPath]="'shared.displayTheLast'"
            ></span>
            <div>
              <ds-form-control-container
                [control]="billingPaymentsHistoryForm.controls['dateRangeMonths']"
              >
                <select
                  id="billAccountDateRangeMonths"
                  class="icon fill"
                  formControlName="dateRangeMonths"
                  data-cy="billAccountDateRangeMonths"
                >
                  @for (month of [1, 3, 6, 12, 24]; track month) {
                    <option [value]="month" data-cy="statementMonth">
                      {{ month }}
                      @if (month === 1) {
                        <span> month</span>
                      }
                      @if (month > 1) {
                        <span data-cy="statementMonths"> months</span>
                      }
                    </option>
                  }
                </select>
                <span class="icon-chevron-down"></span>
              </ds-form-control-container>
            </div>
          </div>
        </form>
      }

      @if (!!rows?.length && (dataLoading | async) === false) {
        <ngx-datatable
          class="none md-block"
          [ngClass]="cssClasses"
          [cssClasses]="{
            pagerLeftArrow: 'icon-chevron-left',
            pagerRightArrow: 'icon-chevron-right',
            pagerPrevious: 'icon-arrow-left-double',
            pagerNext: 'icon-arrow-right-double'
          }"
          [rows]="rows"
          [columns]="columns"
          [columnMode]="'force'"
          [headerHeight]="60"
          [rowHeight]="'auto'"
          [scrollbarH]="true"
          [limit]="pageLimit"
          [footerHeight]="footerHeight"
        >
        </ngx-datatable>
      }

      <ds-table class="block md-none" [rows]="rows" [columns]="columns" [headerHeight]="60">
      </ds-table>

      @if ((statementHistoryLoaded$ | async) === true) {
        <div class="pad-vertical-20">
          @if (!rows?.length && !billAccountNumber) {
            <p
              dsContent
              [contentPath]="'billing.noStatementHistory'"
              data-cy="noStatementHistory"
            ></p>
          }
          @if (!rows?.length && !!billAccountNumber) {
            <p
              dsContent
              [contentPath]="'billing.noStatementHistorySingleAccount'"
              data-cy="noStatementHistorySingleAccount"
            ></p>
          }
          @if (!!rows?.length && isContactBillingToggleEnabled === true) {
            <p>
              <span
                dsContent
                [contentPath]="'billing.billingStatementRequestMorePre'"
                [applicationDependentCopy]="true"
                data-cy="billingStatementRequestMorePre"
              ></span>
              <a
                href="javascript:void(0);"
                [dsRouterLink]="[billingPaths.BILLING_CONTACT, 'billingStatements']"
                data-cy="billingPathsContactStatements"
              >
                <span
                  dsContent
                  [contentPath]="'billing.billingStatementRequestMoreLink'"
                  [applicationDependentCopy]="true"
                  data-cy="billingStatementRequestMoreLink"
                ></span>
              </a>
              <span
                dsContent
                [contentPath]="'billing.billingStatementRequestMorePost'"
                [applicationDependentCopy]="true"
                data-cy="billingStatementRequestMorePost"
              ></span>
            </p>
          }
        </div>
      }
      @if ((statementHistoryLoaded$ | async) === false) {
        <ds-localized-spinner
          [dataLoading]="(statementHistoryLoaded$ | async) === false"
          [loadingMessage]="'Looking for billing statement history...'"
          data-cy="lookingForBillingStatementHistory"
        ></ds-localized-spinner>
      }
    </div>
  </div>
}

<ng-template #headerCellTpl let-column="column">
  <div class="header-cell table-header-cell-wrapper">
    <span
      [ngClass]="{
        'none lg-block': column?.name && column?.shortName,
        block: column?.name && !column?.shortName
      }"
      >{{ column?.name }}</span
    >
    @if (!!column?.shortName) {
      <span class="block lg-none" data-cy="shortName">{{ column?.shortName }}</span>
    }
  </div>
</ng-template>

<ng-template #acctCellTpl let-row="row">
  <div class="acct-cell ds-table-body-cell-header-wrapper">
    @if (!!row) {
      <div class="block md-none ds-table-body-cell-header">
        <h3 class="margin-0">
          <a
            [dsRouterLink]="[billingPaths.BILLING_DETAIL_PAGE, row.billAccountNumber]"
            data-cy="billAccountNumberLink"
          >
            @if (!!row.billAccountNickName) {
              <span title="{{ row.billAccountNickName }}" data-cy="billAccountNickName">{{
                row.billAccountNickName
              }}</span>
            }
            @if (!row.billAccountNickName) {
              <span
                title="{{ row.billAccountNumber | prettyBillingAcctNum }}"
                data-cy="prettyBillingAccountNumber"
                >{{ row.billAccountNumber | prettyBillingAcctNum }}</span
              >
            }
          </a>
        </h3>
      </div>
    }
    <a
      class="none md-block"
      [dsRouterLink]="[billingPaths.BILLING_DETAIL_PAGE, row?.billAccountNumber]"
    >
      @if (!!row.billAccountNickName) {
        <span class="h3" data-cy="billAccountNickName">{{ row.billAccountNickName }}</span>
      }
      @if (!row.billAccountNickName) {
        <span class="h3" data-cy="prettyBillingAccountNumber">{{
          row.billAccountNumber | prettyBillingAcctNum
        }}</span>
      }
    </a>
  </div>
</ng-template>

<ng-template #dateCellTmpl let-row="row">
  <div class="date-cell table-body-cell-label-content ds-table-body-cell-header-wrapper">
    <span class="none md-block ds-table-body-cell-data" data-cy="dateOnDocument">{{
      row.dateOnDocument
    }}</span>

    <span class="ds-table-body-cell-header">
      <h3 class="margin-0" title="{{ row.dateOnDocument }}" data-cy="dateOnDocument">
        {{ row.dateOnDocument }}
      </h3>
    </span>
  </div>
</ng-template>

<ng-template #downloadCellTpl let-row="row">
  <a
    (click)="
      openStatement(
        documentApi +
          'documents/' +
          row.documentId +
          '?levelOfDetails=document&classification=Billing'
      )
    "
    class="no-decoration"
    title="Statement PDF"
    data-cy="statementPDF"
    ><i class="statement icon-pdf" data-cy="pdfIcon"></i>{{ row.language }}</a
  >
</ng-template>

@if (newBillingDesign) {
  <div class="statement-container">
    @if ((statementHistoryLoaded$ | async) === false) {
      <ds-localized-spinner
        [dataLoading]="(statementHistoryLoaded$ | async) === false"
        [loadingMessage]="'Looking for billing statement history...'"
        data-cy="lookingForBillingStatementHistory"
      ></ds-localized-spinner>
    } @else if ((statementHistoryLoaded$ | async) === true) {
      @if (historyList.length <= 0) {
        <div class="pad-vertical-20">
          <p
            dsContent
            [contentPath]="'billing.noStatementHistorySingleAccount'"
            data-cy="noStatementHistorySingleAccount"
          ></p>
        </div>
      } @else {
        <form [formGroup]="statementHistoryForm">
          <div class="row">
            <div class="column twelve md-six">
              <span class="dropdown-label font-size-1 font-weight-semibold">
                {{ statementHistoryCopy.billingHistorySortFormLabel }}
              </span>
              <ds-form-control-container
                [control]="statementHistoryForm.controls['monthRange']"
                class="pad-right-8 pad-bottom-16"
              >
                <select class="icon fill" formControlName="monthRange">
                  @for (month of [12, 24]; track month) {
                    <option [value]="month">
                      {{ statementHistoryCopy.billingHistoryOptionLabel }} {{ month }}
                      <span data-cy="statementMonths">
                        {{ statementHistoryCopy.billingHistoryMonthsLabel }}</span
                      >
                    </option>
                  }
                </select>
                <span class="icon-chevron-down"></span>
              </ds-form-control-container>
            </div>
            <div class="column twelve md-six">
              <span class="dropdown-label font-size-1 font-weight-semibold">
                {{ statementHistoryCopy.billingHistoryAccountFormLabel }}
              </span>
              <ds-form-control-container
                [control]="statementHistoryForm.controls['billAccount']"
                class="pad-left-8 pad-bottom-16"
              >
                <select class="icon fill" formControlName="billAccount">
                  @for (billAccOption of riskDescriptionOption; track billAccOption) {
                    <option [value]="billAccOption">
                      {{ billAccOption }}
                    </option>
                  }
                </select>
                <span class="icon-chevron-down"></span>
              </ds-form-control-container>
            </div>
          </div>
        </form>
        <div class="row statement-tiles">
          @for (statements of statementHistoryList; track statements) {
            <div class="column twelve md-six statement-tile-container">
              <div class="statement-tile tile">
                <div class="row">
                  <a
                    (click)="
                      openStatement(
                        documentApi +
                          'documents/' +
                          statements.documentId +
                          '?levelOfDetails=document&classification=Billing'
                      )
                    "
                    class="no-decoration"
                    title="Statement PDF"
                    data-cy="statementPDF"
                  >
                    <img src="/assets/images/icon-pdf.svg" class="icon-pdf" />
                    <span class="tile-title font-weight-semibold">
                      {{ statements.dateOnDocument | dateFormat: 'MMMM D' }}
                      {{ statementHistoryCopy.billingHistoryStatement }}
                    </span>
                    <img src="/assets/images/icon-new-page.svg" class="icon-new-page" />
                  </a>
                </div>
                <div class="ellipsis-container">
                  <div class="ellipsis font-weight-normal">
                    @if (statements?.riskDescription.length > 1) {
                      @for (riskDesp of statements?.riskDescription; track riskDesp) {
                        {{ riskDesp }}
                      }
                    } @else if (statements?.riskDescription.length === 1) {
                      {{ statements?.riskDescription }}
                    }
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
        <!-- Error info - no data -->
        @if (!statementHistoryList?.length && !billAccountNumber) {
          <p
            dsContent
            [contentPath]="'billing.noStatementHistory'"
            data-cy="noStatementHistory"
          ></p>
        }
        <!-- Information - loaded data count -->
        @if (statementHistoryList?.length > 0) {
          <div class="data-info">
            <span class="font-size-0-75 font-weight-normal">
              {{ statementHistoryCopy.billingHistoryShowingLabel }}
              {{ statementHistoryList?.length }} of {{ filteredStatementHistory?.length }}
              {{ statementHistoryCopy.billingHistoryStatements }}
            </span>
          </div>
        }

        @if (statementHistoryList?.length !== filteredStatementHistory?.length) {
          <div class="items-center text-center more-action">
            <span class="font-size-1 font-weight-semibold" (click)="loadMore()">
              {{ statementHistoryCopy.billingHistoryShowMore }}
              <img src="/assets/images/chevron-down-thick.svg" />
            </span>
          </div>
        }
      }
    }
  </div>
}
